import { h, Component, Fragment } from 'preact';
import * as actions from 'components/utils/actions';
import pure from 'utils/pure';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';

import s from 'components/shared/modal/modal.sss';

export default
@pure
class Modal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			active: false,
			// active: false,
			content: null,
		};

		this.hideModal = this.setModalDisplay.bind(this);
	}

	componentDidMount() {
		Store.on(actions.HIDE_MODAL, this.setModalDisplay.bind(this));
		Store.on(actions.SHOW_MODAL, this.setModalDisplay.bind(this));
	}

	componentWillUnmount() {
		Store.off(actions.HIDE_MODAL, this.setModalDisplay);
		Store.off(actions.SHOW_MODAL, this.setModalDisplay);
	}

	setModalDisplay(content) {
		const store = Store.get();
		if (content) {
			store.set('modalActive', true);
			this.setState({ active: true, content });
		} else {
			store.set('modalActive', false);
			this.setState({ active: false, content: null });
		}
	}

	render() {
		const { active, content } = this.state;
		const store = Store.get();
		const iconDesc = store.appData.copy.baseCopy?.modalCloseIcon || 'A close icon';
		return (
			<div class={joinClasses(s.modalWrap, active ? s.active : ' ')}>
				<div onClick={() => this.setModalDisplay(null)} class={s.curtain} />
				<div class={s.modal}>
					<button onClick={() => this.setModalDisplay(null)} class={s.closeButton}>
						<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
							<title>{ iconDesc }</title>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M11.5594 10.5004L20.7784 1.28137C21.0709 0.988875 21.0709 0.513375 20.7784 0.220875C20.4859 -0.071625 20.0104 -0.071625 19.7179 0.220875L10.4989 9.43987L1.27988 0.219375C0.987375 -0.073125 0.511875 -0.073125 0.219375 0.219375C-0.073125 0.511875 -0.073125 0.987375 0.219375 1.27987L9.43838 10.5004L0.219375 19.7194C-0.073125 20.0119 -0.073125 20.4874 0.219375 20.7799C0.364875 20.9269 0.556875 21.0004 0.748875 21.0004C0.940875 21.0004 1.13288 20.9269 1.27988 20.7814L10.4989 11.5609L19.7179 20.7799C19.8649 20.9269 20.0569 21.0004 20.2489 21.0004C20.4409 21.0004 20.6329 20.9269 20.7799 20.7814C21.0724 20.4889 21.0724 20.0134 20.7799 19.7209L11.5594 10.5004Z"
							/>
						</svg>
					</button>
					{content}
				</div>
			</div>
		);
	}
}
